import { ChatBot } from 'apis/chatbots';
import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import {
  InitialParams,
  StandardParams,
  UsePaginatedEndpointResult,
} from 'hooks/usePaginatedEndpoint/types';

import { getChatBots } from './api';

type Params = StandardParams<null>;
type SortKey = null;

export const useChatBots = (
  initialParams?: InitialParams<SortKey, Params>,
): UsePaginatedEndpointResult<ChatBot, SortKey, Params> =>
  usePaginatedEndpoint<ChatBot, ChatBot[], SortKey, Params>({
    endpoint: getChatBots,
    itemsSelector: (data) => data,
    initialParams: { ...initialParams },
  });
